import { create } from 'zustand';

type WaitingStore = {
  waitingCount: number;
  isWaiting: boolean;
  setIsWaiting: (value: boolean) => void;
  resetWaiting: () => void;
};

export const useWaitingStore = create<WaitingStore>((set, get) => ({
  waitingCount: 0,
  isWaiting: false,

  setIsWaiting: (value: boolean) => {
    const count = get().waitingCount + (value ? 1 : -1);
    const safeCount = Math.max(count, 0);

    set({
      waitingCount: safeCount,
      isWaiting: safeCount > 0
    });
  },

  resetWaiting: () => set({ waitingCount: 0, isWaiting: false })
}));
